import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { McColorModule } from '@portal-core/ui/themes/directives/mc-color.module';
import { LicenseSecurityFormComponent } from './license-security-form.component';

@NgModule({
  declarations: [
    LicenseSecurityFormComponent
  ],
  imports: [
    McColorModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatCheckboxModule,
    MatDialogModule,
    LoaderModule
  ],
  exports: [
    LicenseSecurityFormComponent
  ]
})
export class LicenseSecurityFormModule { }
